import React from 'react';
import { AlertCircle, RefreshCw } from "lucide-react";

const EmptyState = ({ 
  onRefresh, 
  title = "No team members found",
  message = "Get started by adding your first team member.",
  showRefresh = true 
}) => (
  <div className="py-12 text-center">
    <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-gray-100 rounded-full">
      <AlertCircle className="w-8 h-8 text-gray-400" />
    </div>
    <h3 className="mb-2 text-lg font-medium text-gray-900">{title}</h3>
    <p className="mb-4 text-gray-500">{message}</p>
    {showRefresh && onRefresh && (
      <button
        onClick={onRefresh}
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#FF6C6C] hover:bg-[#ff4848] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF6C6C]"
      >
        <RefreshCw className="mr-2 w-4 h-4" />
        Refresh
      </button>
    )}
  </div>
);

export default EmptyState;